<template>
  <div class="container-fluid p-0">
    <PageTitle :title="$t('label.ocorrencias')" :titleAdd="$t('label.addOcorrencia')" :isAdd="true"/>
    <!-- filtro -->
    <div class="row">
      <div class="col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-body p-0 box-dashboard">
            <div class="align-self-center">
              <form class="filtro_especie" @submit.prevent="search">
                <div class="row g-3 p-3 pb-0">
                  <div class="col-12 col-md-6 col-lg-6">
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value="1" v-model="$store.state.formSearch.species_type">
                        <label class="form-check-label" for="inlineRadio1">{{ $t('label.invasoras') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" :value="2" v-model="$store.state.formSearch.species_type">
                        <label class="form-check-label" for="inlineRadio2">{{ $t('label.contidasBrasil') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" :value="3" v-model="$store.state.formSearch.species_type">
                        <label class="form-check-label" for="inlineRadio3">{{ $t('label.ausentesBrasil') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio4" :value="4" v-model="$store.state.formSearch.species_type">
                        <label class="form-check-label" for="inlineRadio4">{{ $t('label.deficiencia') }}</label>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-6 text-right">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="byApp" v-model="$store.state.formSearch.by_app">
                      <label class="form-check-label" for="byApp">{{ $t('label.byApp') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" id="pendenteAnalise" v-model="$store.state.formSearch.pending_analysis">
                      <label class="form-check-label" for="pendenteAnalise">{{ $t('label.pendenteAnalise') }}</label>
                    </div>
                  </div>
                </div>
                <div class="row g-3 p-3 pb-0">
                  <div class="col-12 col-lg-4">
                    <v-select :appendToBody="true" :filterable="false" @search="getSpecies" :options="speciesList" v-model="$store.state.formSearch.species_id" label="scientific_name" index="species_id"
                      :reduce="r => r.species_id" :clearable="false" class="bg-laranja-select vue-select">
                      <template v-slot:selected-option="option">
                        {{ `${option.scientific_name}` }}
                      </template>
                      <template v-slot:option="option">
                        {{ `${option.scientific_name}` }}
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                        </template>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"><img src="/img/arrow-drop-white.1894748c.svg"/></span>
                      </template>
                    </v-select>
                  </div>
                  <div class="col-12 col-lg-4">
                    <v-select :appendToBody="true" :options="statesList" v-model="$store.state.formSearch.state_id" label="state" index="state_id"
                      :reduce="r => r.state_id" :clearable="false" class="bg-laranja-select vue-select">
                      <template v-slot:selected-option="option">
                        {{ `${option.state}` }}
                      </template>
                      <template v-slot:option="option">
                        {{ `${option.state}` }}
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                        </template>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"><img src="/img/arrow-drop-white.1894748c.svg"/></span>
                      </template>
                    </v-select>
                  </div>
                  <div class="col-12 col-lg-4">
                    <v-select :appendToBody="true" @search="getVocMunicipios" :options="vocMunicipiosList" v-model="$store.state.formSearch.municipio_id" label="municipio" index="municipio_id"
                      :reduce="r => r.municipio_id" :clearable="false" class="bg-laranja-select vue-select">
                      <template v-slot:selected-option="option">
                        {{ `${option.municipio}` }}
                      </template>
                      <template v-slot:option="option">
                        {{ `${option.municipio}` }}
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                        </template>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"><img src="/img/arrow-drop-white.1894748c.svg"/></span>
                      </template>
                    </v-select>
                  </div>
                  <div class="col-12 col-lg-4">
                    <v-select :appendToBody="true" :options="vocProtectedAreaList" v-model="$store.state.formSearch.protected_area_id" label="value" index="protected_area_id"
                      :reduce="r => r.protected_area_id" :clearable="false" class="bg-laranja-select vue-select">
                      <template v-slot:selected-option="option">
                        {{ `${option.value}` }}
                      </template>
                      <template v-slot:option="option">
                        {{ `${option.value}` }}
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                        </template>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"><img src="/img/arrow-drop-white.1894748c.svg"/></span>
                      </template>
                    </v-select>
                  </div>
                  <div class="col-12 col-lg-4">
                    <v-select :appendToBody="true" :options="vocEnvironmentsList" v-model="$store.state.formSearch.environment_id" label="value" index="environment_id"
                      :reduce="r => r.environment_id" :clearable="false" class="bg-laranja-select vue-select">
                      <template v-slot:selected-option="option">
                        {{ `${option.value}` }}
                      </template>
                      <template v-slot:option="option">
                        {{ `${option.value}` }}
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                        </template>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"><img src="/img/arrow-drop-white.1894748c.svg"/></span>
                      </template>
                    </v-select>
                  </div>

                  <div class="col-12 col-lg-4 ml-auto text-right pt-1">
                    <button type="button" @click="clear" class="btn btn-outline-secondary mt-1 mb-2 mr-1">
                      {{ $t('label.limpar') }}
                    </button>
                    <button type="submit" class="btn bt-filtrar mt-1 mb-2">
                      {{ $t('label.buscar') }}
                    </button>
                  </div>
                </div>
              </form>

              <div class="row mt-1 mt-xl-2 p-3 bg_table_header">
                <div class="col-auto d-none d-sm-block">
                  <p class="mb-0 mt-2">
                    {{ $t('label.numRegistrosEncontrados') }}
                    <span class="laranja">{{$store.state.countList}}</span>
                  </p>
                </div>

                <div class="col-auto ml-auto text-right select_registro">
                  <select class="selectpicker" ref="select" v-model="$store.state.perPage" @change="search">
                    <option selected value="10">{{ $t('label.exibir10Reg') }}</option>
                    <option value="25">{{ $t('label.exibir25Reg') }}</option>
                    <option value="50">{{ $t('label.exibir50Reg') }}</option>
                    <option value="100">{{ $t('label.exibir100Reg') }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /filtro -->

    <!-- tabela -->
    <div class="row">
      <div class="col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-body box-dashboard p-0">
              <OcorrenciasTable @orderBy="orderBy" @search="search" :items="items"/>
          </div>
        </div>
      </div>
    </div>
    <!-- /tabela -->
  </div>
</template>

<script>
import axios from 'axios'
import PageTitle from '@/components/shared/PageTitle'
import OcorrenciasTable from './OcorrenciasTable.vue'
export default {
  name: 'Ocorrencias',
  components: { OcorrenciasTable, PageTitle },
  data: function () {
    return {
      items: [],
      speciesList: [{ species_id: '', scientific_name: this.$t('label.nomeCientifico') }],
      statesList: [{ state_id: '', state: this.$t('label.estado') }],
      vocMunicipiosList: [{ municipio_id: '', municipio: this.$t('label.municipio') }],
      vocEnvironmentsList: [{ environment_id: '', value: this.$t('label.ambiente') }],
      vocProtectedAreaList: [{ protected_area_id: '', value: this.$t('label.areaProtegida') }],
      dataOrderBy: {}
    }
  },
  watch: {
    '$store.state.formSearch.state_id' (newValue, oldValue) {
      if (oldValue !== undefined) {
        this.$store.state.formSearch.municipio_id = ''
        this.$store.state.formSearch.protected_area_id = ''
      }
      this.getVocMunicipios()
      this.getVocProtectedArea()
    }
  },
  methods: {
    clear: function () {
      this.$store.commit('clearFormSearch')
    },
    orderBy: function (dataOrderBy) {
      this.$store.state.dataOrderBy = dataOrderBy
      this.search()
    },
    setFormOrderBy: function () {
      this.$store.state.formSearch.OrderBySpecieScientificNameAcs = this.$store.state.dataOrderBy.OrderBySpecieScientificNameAcs
      this.$store.state.formSearch.OrderBySpecieScientificNameDesc = this.$store.state.dataOrderBy.OrderBySpecieScientificNameDesc
      this.$store.state.formSearch.OrderByStateAcs = this.$store.state.dataOrderBy.OrderByStateAcs
      this.$store.state.formSearch.OrderByStateDesc = this.$store.state.dataOrderBy.OrderByStateDesc
      this.$store.state.formSearch.OrderByMunicipioAcs = this.$store.state.dataOrderBy.OrderByMunicipioAcs
      this.$store.state.formSearch.OrderByMunicipioDesc = this.$store.state.dataOrderBy.OrderByMunicipioDesc
      this.$store.state.formSearch.OrderByProtectedAreaAcs = this.$store.state.dataOrderBy.OrderByProtectedAreaAcs
      this.$store.state.formSearch.OrderByProtectedAreaDesc = this.$store.state.dataOrderBy.OrderByProtectedAreaDesc
      this.$store.state.formSearch.OrderByIDAcs = this.$store.state.dataOrderBy.OrderByIDAcs
      this.$store.state.formSearch.OrderByIDDesc = this.$store.state.dataOrderBy.OrderByIDDesc
    },
    getSpecies: function (search, loading) {
      const params = {
        Page: 1,
        PageSize: 9999
      }
      if (search && search.length > 2) {
        params.scientific_name = search
        params.species_id_array = this.$store.state.formSearch.species_id
        loading(true)
        axios.get('/Specie/getallcombo', { params })
          .then(response => {
            this.speciesList = response.data.items
            this.speciesList.unshift({ species_id: '', scientific_name: this.$t('label.nomeCientifico') })
            loading(false)
          })
      } else if (!search) {
        params.species_id_array = this.$store.state.formSearch.species_id
        axios.get('/Specie/getallcombo', { params })
          .then(response => {
            this.speciesList = response.data.items
            this.speciesList.unshift({ species_id: '', scientific_name: this.$t('label.nomeCientifico') })
          })
      }
    },
    getStates: function () {
      const params = { Page: 1, PageSize: 9999 }
      axios.get('/VocStates/getall', { params })
        .then(response => {
          this.statesList = response.data.items
          this.statesList.unshift({ state_id: '', state: this.$t('label.estado') })
        })
    },
    getVocMunicipios: function (search, loading) {
      const params = {
        Page: 1,
        PageSize: 30,
        State_id: this.$store.state.formSearch.state_id ? this.$store.state.formSearch.state_id : null
      }
      if (search && search.length > 2) {
        params.municipio = search
        params.municipio_id = this.$store.state.formSearch.municipio_id === '' ? null : this.$store.state.formSearch.municipio_id
        loading(true)
        axios.get('/VocMunicipios/getall', { params })
          .then(response => {
            this.vocMunicipiosList = response.data.items
            this.vocMunicipiosList.unshift({ municipio_id: '', municipio: this.$t('label.municipio') })
            loading(false)
          })
      } else if (!search) {
        params.municipio_id = this.$store.state.formSearch.municipio_id === '' ? null : this.$store.state.formSearch.municipio_id
        axios.get('/VocMunicipios/getall', { params })
          .then(response => {
            this.vocMunicipiosList = response.data.items
            this.vocMunicipiosList.unshift({ municipio_id: '', municipio: this.$t('label.municipio') })
          })
      }
    },
    getVocEnvironments: function () {
      const params = { Page: 1, PageSize: 9999 }
      axios.get('/VocEnvironments/getall', { params })
        .then(response => {
          this.vocEnvironmentsList = response.data.items.map(i => {
            const item = {
              environment_id: i.environment_id,
              value: ''
            }
            switch (this.$i18n.locale) {
              case 'en':
                item.value = i.en
                break
              case 'es':
                item.value = i.es
                break
              case 'pt':
                item.value = i.pt
                break
            }
            return item
          })
          this.vocEnvironmentsList.unshift({ environment_id: '', value: this.$t('label.ambiente') })
        })
    },
    getVocProtectedArea: function () {
      const params = {
        Page: 1,
        PageSize: 9999,
        State_id: this.$store.state.formSearch.state_id ? this.$store.state.formSearch.state_id : null
      }
      axios.get('/VocProtectedArea/getall', { params })
        .then(response => {
          this.vocProtectedAreaList = response.data.items.map(i => {
            const item = {
              protected_area_id: i.protected_area_id,
              value: i.protected_area
            }
            return item
          })
          this.vocProtectedAreaList.unshift({ protected_area_id: '', value: this.$t('label.areaProtegida') })
        })
    },
    search: async function () {
      this.$store.dispatch('showPreload')

      this.setFormOrderBy()
      const params = this.$store.state.formSearch
      params.Page = this.$store.state.currentPage
      params.PageSize = this.$store.state.perPage
      await axios.get('/DataPlaces/getallgrid', { params })
        .then(response => {
          this.$store.state.currentPage = response.data.page
          this.$store.state.countList = response.data.count
          this.items = response.data.items
        })
    }
  },
  created: async function () {
    this.$store.state.formSearch.pending_analysis = true
    await this.search()
    this.getSpecies()
    this.getStates()
    this.getVocMunicipios()
    this.getVocEnvironments()
    this.getVocProtectedArea()
  }
}
</script>
